module.exports = __webpack_public_path__ + "static/img/logo.185d7da4.svg";